import React, { Component, useState, useEffect } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	CardFooter,
	Row,
	Col,
	Table,
	Badge,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { AvForm } from "availity-reactstrap-validation";
import TableScrollbar from "react-table-scrollbar";

import "../PurchaseIndentRequest.scss";

import Moment from "moment";

import {
	getPIReqestRowDetails,
	SRDetailsModel_open,
	getMrItemImages,
	productItemHistoryModelOpen,
} from "../../../store/SRPurchaseIndent/actions";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import GetMRDetails from "../../GetSRDetails";
import LoadingModel from "../../LoadingModel";

import ItemDetails from "../../ItemDetails";
import PIProductItemHistoryLog from "../PIProductItemHistoryLog";

function PdfViewer({ url }) {
	const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

	useEffect(() => {
		const fetchPdf = async () => {
			try {
				let finalUrl = url;

				if (
					window.location.hostname === "localhost" &&
					url.startsWith("http://vendpin.dev.absol.in")
				) {
					finalUrl = url.replace("http://vendpin.dev.absol.in", "");
				}

				const response = await fetch(finalUrl);
				console.log(finalUrl, "finalurl");
				if (!response.ok)
					throw new Error("Network response was not ok");

				const blob = await response.blob();
				const blobUrl = URL.createObjectURL(blob);
				setPdfBlobUrl(blobUrl);
			} catch (err) {
				console.error("Failed to load PDF", err);
			}
		};
		fetchPdf();
	}, [url]);

	if (!pdfBlobUrl)
		return <p style={{ padding: "10px" }}>Loading PDF preview...</p>;

	return (
		<iframe
			src={pdfBlobUrl}
			width="100%"
			height="600px"
			style={{ border: "none" }}
			title="PDF Document"
		/>
	);
}

class PurchaseOrder extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			isAlertOpen: false,
			request_items: [],
			products: [],
			productdata: {},
			selectedOrderLocation: null,
			showImageModal: false,
		};

		this.removeCartItem.bind(this);
		this.tog_static = this.tog_static.bind(this);
	}
	tog_static(item) {
		this.setState((prevState) => ({
			modal_static: !prevState.modal_static,
			productdata: item,
		}));
		if (item?.siisris.length !== 0) {
			this.props.getMrItemImages(
				item.id,
				item?.siisris[item?.siisris.length - 1]?.sritem?.id
			);
		}
		this.removeBodyCss();
	}

	removeBodyCss() {
		document.body.classList.add("no_padding");
	}
	removeCartItem = (id, reject) => {
		if (reject === 0) {
			let products = this.state.request_items;
			var filtered = products.filter(function (item) {
				return item.id !== id;
			});

			this.setState({ request_items: filtered });
		}
	};

	componentDidMount() {
		this.props.getPIReqestRowDetails(
			this.props.match.params.id,
			this.props.history
		);
	}

	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						{this.props.loading && (
							<LoadingModel OpenModel={this.props.loading} />
						)}

						<AvForm className="needs-validation">
							<Row>
								<Col md={12}>
									<Card className="mb-0 mt-0">
										<CardHeader className="bg-transparent border-bottom ">
											<Link
												to="/srpidashboard"
												className="action-icon text-primary mr-2">
												<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
											</Link>

											<h5 className="card-title-18 pt-2 d-inline-block">
												SR Service Indent Request(#
												{this.props.PIreqRowData?.code})
											</h5>
											<div className="float-right">
												<div className="d-inline-block ">
													<Link
														to={
															"/sireportdoc/" +
															this.props.match
																.params.id
														}
														className="action-icon text-primary mr-2">
														<Button
															type="button"
															outline
															color="secondary"
															className=" mr-2">
															<i className="mdi  mdi-printer"></i>
															<span className="d-none d-inline-block ml-1">
																Print
															</span>
														</Button>
													</Link>
												</div>
											</div>
										</CardHeader>
										<CardBody className="pt-1">
											<Row className="p-1">
												<Col
													md={12}
													className="p-1 m-0 border-bottom">
													<div className="p-1 m-0">
														<CardBody className="pt-1 pb-1">
															<Row className="p-0">
																<Col
																	md={8}
																	className="p-1 m-0">
																	<div className="Indent-Request-panel-content">
																		<div className="list-column">
																			<Row>
																				<Col
																					md={
																						6
																					}>
																					<ul className="list-style-two p-0">
																						<li className="clearfix">
																							<span className="ttl">
																								Request
																								By:
																							</span>
																							<span className="dtl">
																								{
																									this
																										.props
																										.PIreqRowData
																										?.createdby
																										.fullname
																								}
																							</span>
																						</li>
																						<li className="clearfix">
																							<span className="ttl">
																								Location:{" "}
																							</span>
																							<span className="dtl">
																								{
																									this
																										.props
																										.PIreqRowData
																										?.location
																										.name
																								}
																							</span>
																						</li>

																						<li className="clearfix">
																							<span className="ttl">
																								Order
																								Location:
																							</span>
																							<span className="dtl">
																								{
																									this
																										.props
																										.PIreqRowData
																										?.orderlocation
																										?.name
																								}

																								{this
																									.props
																									.PIreqRowData
																									?.orderlocation
																									?.image && (
																									<Button
																										color="info"
																										size="sm"
																										className="ml-2"
																										onClick={() =>
																											this.setState(
																												{
																													selectedOrderLocation:
																														this
																															.props
																															.PIreqRowData
																															?.orderlocation,
																													showImageModal: true,
																												}
																											)
																										}>
																										View
																									</Button>
																								)}
																							</span>
																						</li>

																						<li className="clearfix">
																							<span className="ttl">
																								User
																								Department:
																							</span>
																							<span className="dtl">
																								{
																									this
																										.props
																										.PIreqRowData
																										?.userdepartment
																										.name
																								}
																							</span>
																						</li>
																						<li className="clearfix">
																							<span className="ttl">
																								description:
																							</span>
																							<span className="dtl">
																								{
																									this
																										.props
																										.PIreqRowData
																										?.description
																								}
																							</span>
																						</li>
																					</ul>
																				</Col>
																				<Col
																					md={
																						6
																					}>
																					<ul className="list-style-two p-0">
																						<li className="clearfix">
																							<span className="ttl">
																								Department:
																							</span>
																							<span className="dtl">
																								{
																									this
																										.props
																										.PIreqRowData
																										?.department
																										.name
																								}
																							</span>
																						</li>
																						<li className="clearfix">
																							<span className="ttl">
																								Submited
																								Date:
																							</span>
																							<span className="dtl">
																								{" "}
																								{Moment(
																									this
																										.props
																										.PIreqRowData
																										?.createdon
																								).format(
																									"DD-MM-YYYY"
																								)}
																							</span>
																						</li>
																						<li className="clearfix">
																							<span className="ttl">
																								Status:
																							</span>

																							<span className="dtl font-size-18">
																								<Badge
																									color={
																										this
																											.props
																											.PIreqRowData
																											?.sistatus ===
																											1 ||
																										this
																											.props
																											.PIreqRowData
																											?.sistatus ===
																											2
																											? "primary "
																											: this
																													.props
																													.PIreqRowData
																													?.sistatus ===
																											  3
																											? "success "
																											: "danger "
																									}>
																									{
																										this
																											.props
																											.PIreqRowData
																											?.sistatus_name
																									}
																								</Badge>
																							</span>
																						</li>
																					</ul>
																				</Col>
																			</Row>
																		</div>
																	</div>
																</Col>
																<Col
																	md={4}
																	className="p-0 mt-0"></Col>
															</Row>
														</CardBody>
													</div>
												</Col>
												<Col
													md={12}
													xl={
														this.state
															.showImageModal
															? 5
															: 8
													}
													className="p-1">
													<div className="p-1">
														<Col
															md={12}
															className="m-0">
															<div
																style={{
																	textAlign:
																		"left",
																	background:
																		"#FFF",
																	padding:
																		"5px;",
																}}>
																<h3 className="card-title-15 pt-2">
																	Purchase
																	Indent Items
																	List
																</h3>
															</div>
															<div className="table-responsive m-0">
																<TableScrollbar height="450px">
																	<Table className="mb-0 p-0 table-centered  ">
																		<thead className="bg-light text-center">
																			<tr>
																				<th className="nowrap">
																					SR
																					Details
																				</th>
																				<th className="nowrap">
																					Item
																					Images
																				</th>
																				<th
																					style={{
																						minWidth:
																							"220px",
																					}}>
																					Item
																					Name
																				</th>
																				<th className="nowrap">
																					Required
																					Qty
																				</th>
																				<th className="nowrap">
																					Indent
																					Quantity
																				</th>
																				<th className="nowrap">
																					Department
																				</th>
																				<th className="nowrap">
																					Action
																				</th>
																			</tr>
																		</thead>
																		<tbody className=" text-center">
																			{this.props.PIreqRowData?.siitems?.map(
																				(
																					item,
																					key
																				) => (
																					<tr
																						key={
																							key
																						}>
																						<td className="nowrap text-center">
																							{item
																								?.siisris
																								.length ===
																							0 ? (
																								<>
																									<span>
																										{" "}
																										<u>
																											View
																										</u>
																									</span>
																								</>
																							) : (
																								<Link
																									to="#"
																									onClick={() => {
																										this.props.SRDetailsModel_open(
																											item
																												?.siisris[
																												item
																													?.siisris
																													.length -
																													1
																											]
																												.sritem
																												?.servicerequest_id
																										);
																									}}
																									className="text-primary mr-1">
																									<u>
																										View
																									</u>
																								</Link>
																							)}
																						</td>
																						<td className="nowrap text-center">
																							<div className="product-detail text-center">
																								<img
																									src={
																										item
																											?.product
																											?.image ==
																										null
																											? DefaultImg
																											: item
																													?.product
																													?.image
																									}
																									alt="product-img"
																									title="product-img"
																									className="product-img  img-fluid mx-auto tab-img rounded"
																									style={{
																										height: "100px",
																										width: "150px",
																									}}
																								/>
																							</div>
																						</td>
																						<td className="text-left">
																							<h5 className="font-size-14 ">
																								<Link
																									to="#"
																									onClick={() => {
																										this.tog_static(
																											item
																										);
																									}}
																									className="text-primary mr-1">
																									{
																										item
																											?.product
																											.name
																									}
																								</Link>
																								{item
																									.siisris
																									.length ===
																									0 && (
																									<Badge color="primary">
																										new
																									</Badge>
																								)}
																								{item
																									?.sii_approvals
																									.length !==
																									0 && (
																									<>
																										<Link
																											to="#"
																											onClick={() => {
																												this.props.productItemHistoryModelOpen(
																													item.sii_approvals
																												);
																											}}
																											className="text-dark">
																											<i className=" text-primary ri-eye-fill ml-2"></i>
																										</Link>
																									</>
																								)}
																							</h5>
																							<p className="mb-0">
																								Make
																								:{" "}
																								<span className="font-weight-medium">
																									{
																										item.make
																									}
																								</span>
																							</p>
																							<p className="mb-0">
																								Description
																								:{" "}
																								<span className="font-weight-medium">
																									{
																										item.description
																									}
																								</span>
																							</p>
																							{/* {item.sistatus === 4 && (
                                                <p className="mb-0">
                                                  <b className="text-danger ">
                                                    Reject Remark :
                                                  </b>{" "}
                                                  <span>
                                                    {
                                                      item.mri_approvals[
                                                        item.mri_approvals
                                                          .length - 1
                                                      ].description
                                                    }
                                                  </span>
                                                </p>
                                              )} */}
																						</td>
																						<td className="nowrap text-center">
																							{item
																								.sii_approvals
																								.length ===
																							0
																								? item.qty +
																								  " " +
																								  item
																										.unit
																										?.name
																								: item
																										.sii_approvals[0]
																										.f_qty +
																								  " " +
																								  item
																										.sii_approvals[0]
																										.f_unit
																										.name}
																						</td>
																						<td className="nowrap text-center">
																							{
																								item.qty
																							}{" "}
																							{
																								item
																									?.unit
																									.name
																							}
																						</td>
																						<td className="nowrap text-center">
																							{
																								item
																									.product
																									.department
																									?.name
																							}
																						</td>

																						<td className="nowrap text-center">
																							<Button
																								type="button"
																								color={
																									item.sistatus ===
																										1 ||
																									item.sistatus ===
																										2
																										? "primary"
																										: item.sistatus ===
																												3 ||
																										  item.sistatus ===
																												7 ||
																										  item.sistatus ===
																												8
																										? "success"
																										: "danger"
																								}
																								className="waves-effect waves-light mr-2"
																								disabled={
																									true
																								}>
																								{
																									item.sistatus_name
																								}
																							</Button>
																						</td>
																					</tr>
																				)
																			)}
																		</tbody>
																	</Table>
																</TableScrollbar>
															</div>
														</Col>
													</div>
												</Col>

												{this.state.showImageModal &&
													this.state
														.selectedOrderLocation
														?.image && (
														<Col md={12} xl={3}>
															<Card className="p-1">
																<CardHeader>
																	<h5>
																		Order
																		Location
																		Document:{" "}
																		{
																			this
																				.state
																				.selectedOrderLocation
																				.name
																		}
																	</h5>
																	<Button
																		color="secondary"
																		size="sm"
																		className="float-right"
																		onClick={() =>
																			this.setState(
																				{
																					showImageModal: false,
																				}
																			)
																		}>
																		Close
																	</Button>
																</CardHeader>
																<CardBody className="p-0">
																	{this.state.selectedOrderLocation.image.includes(
																		".pdf"
																	) ? (
																		<PdfViewer
																			url={
																				this
																					.state
																					.selectedOrderLocation
																					.image
																			}
																		/>
																	) : (
																		<img
																			src={
																				this
																					.state
																					.selectedOrderLocation
																					.image
																			}
																			alt="Order Location"
																			style={{
																				maxWidth:
																					"100%",
																				height: "auto",
																			}}
																		/>
																	)}
																</CardBody>
															</Card>
														</Col>
													)}
											</Row>
											<CardFooter className="bg-transparent pt-0">
												<div className="float-right">
													<Button
														type="reset"
														color="light"
														className="waves-effect waves-light mr-2"
														href="/PurchaseIndentDashboard">
														Cancel
													</Button>
												</div>
											</CardFooter>
										</CardBody>
									</Card>
								</Col>
							</Row>
						</AvForm>
						<ItemDetails
							modelOpen={this.state.modal_static}
							item={this.state.productdata}
							ItemLevel="PILevel"
							modelClose={() => {
								this.setState({ modal_static: false });
							}}
						/>
						<PIProductItemHistoryLog />
						<GetMRDetails />
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { PIreqRowData, loading } = state.SRpurchaseIndent;
	return { PIreqRowData, loading };
};

export default connect(mapStatetoProps, {
	getPIReqestRowDetails,
	SRDetailsModel_open,
	getMrItemImages,
	productItemHistoryModelOpen,
	// addPurchaseIndentApprovedRequest,
})(PurchaseOrder);
